var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientbluecircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.16 192.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -624.72,
    y1: 852.82,
    x2: -432.56,
    y2: 852.82,
    gradientTransform: "translate(624.72 -756.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e7f9ff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b8eeff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8fe5ff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6eddff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#54d7ff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#42d3ff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#37d0ff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33cfff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.08,
    cy: 96.08,
    r: 96.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientbluecircle);
export default __webpack_public_path__ + "static/media/gradient blue circle.897fffc4c4a1ec008ce048a6f3f00c2f.svg";
export { ForwardRef as ReactComponent };